import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { transition, style, animate, trigger } from '@angular/animations';
import { ViewService } from 'src/app/view/view.service';
import { Store, Select } from '@ngxs/store';
import { ViewState } from 'src/app/view/state/view.state';
import { Subject, Observable, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ViewUIService } from 'src/app/view/view-ui.service';
import { ViewUI } from 'src/app/view/models/view-ui.enum';
import { EnvironmentApplication } from 'src/environments/models/environment-application';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ViewUIModel } from 'src/app/view/models/view-ui.model';
import { QuizState } from 'src/app/quiz/state/quiz.state';

@Component({
  selector: 'app-view-column-container',
  templateUrl: './view-column-container.component.html',
  styleUrls: ['./view-column-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ 
          transform: 'translateX(-320px)'
        }),
        animate('300ms ease-in-out', style({ 
          transform: '*'
        }))
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ 
          transform: 'translateX(-320px)'
        }))
      ])
    ])
  ]

})
export class ViewColumnContainerComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------
  @Select(StoryChaptersState.getSelectedChapter)
  chapter$: Observable<ChapterModel>;

  @Select(ViewState.getUI)
  layout$: Observable<ViewUIModel>;

  @Select(QuizState.getQuizModeActive)
  quizModeActive$: Observable<boolean>;


  // ---------- Class Variables ----------
  ngUnsubscribe = new Subject();
  viewLayout = ViewUI;
  application = EnvironmentApplication;
  
  columnVisible = false;
  searchVisible = false;
  nodeInfoVisible = false;

  
  // ---------- Lifecycle Events ----------
  constructor(
    private viewService: ViewService,
    private layoutService: ViewUIService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.initLayoutObserver();
  }
  
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  
  
  // ---------- Layout ----------
  initLayoutObserver() {
    combineLatest(
      this.layout$,
      this.chapter$
    )
    .pipe(
      takeUntil(this.ngUnsubscribe)
    )
    .subscribe(([]) => {
      this.columnVisible = this.layoutService.isVisible(ViewUI.Column);
      this.searchVisible = this.layoutService.isVisible(ViewUI.Search);
      this.nodeInfoVisible = this.layoutService.isVisible(ViewUI.NodeInfo);
      this.changeDetectorRef.markForCheck();
    });
  }

  handleSearchClick() {
    this.viewService.toggleSearch(true);
  }
}
